import { AppStrings } from "../constants/AppStrings";

export const PAM_MFA_ERROR_CODES = Object.freeze({
  CODE_MISMATCH: "MFA_CODE_MISMATCH",
  CODE_EXPIRED: "MFA_CODE_EXPIRED",
  SESSION_EXPIRED: "MFA_SESSION_EXPIRED",
  ENROLLMENT_TICKET_EXPIRED: "MFA_ENROLLMENT_TICKET_EXPIRED",
  RATE_LIMITED: "MFA_RATE_LIMITED",
  NOT_AVAILABLE: "MFA_NOT_AVAILABLE",
  FEATURE_DISABLED: "MFA_FEATURE_DISABLED",
});

const PAM_MFA_ERROR_CODE_SET = new Set(
  Object.values(PAM_MFA_ERROR_CODES),
);

export const getPamMfaErrorCode = (error) => {
  const errorCode = error?.response?.data?.error_code;
  return typeof errorCode === "string" &&
    PAM_MFA_ERROR_CODE_SET.has(errorCode)
    ? errorCode
    : "";
};

export const getPamMfaErrorMessage = (error) => {
  switch (error?.response?.data?.msg_code) {
    case "pam.error.mfa_code_mismatch":
      return AppStrings.PAM_2FA_CODE_MISMATCH;
    case "pam.error.mfa_code_expired":
      return AppStrings.PAM_2FA_CODE_EXPIRED;
    case "pam.error.mfa_session_expired":
      return AppStrings.PAM_2FA_AUTH_SESSION_EXPIRED;
    case "pam.error.mfa_enrollment_ticket_expired":
      return AppStrings.PAM_2FA_ENROLLMENT_TICKET_EXPIRED;
    case "pam.error.mfa_rate_limited":
      return AppStrings.PAM_2FA_RATE_LIMITED;
    case "pam.error.mfa_not_available":
      return AppStrings.PAM_2FA_NOT_AVAILABLE;
    case "pam.error.mfa_feature_disabled":
      return AppStrings.PAM_2FA_FEATURE_DISABLED;
    default:
      return (
        error?.response?.data?.message ||
        AppStrings.PAM_GENERIC_REQUEST_FAILED
      );
  }
};

export const buildPamTotpUri = ({ issuer, username, secret }) => {
  const label = `${encodeURIComponent(issuer)}:${encodeURIComponent(username)}`;
  const query = [
    `secret=${encodeURIComponent(secret)}`,
    `issuer=${encodeURIComponent(issuer)}`,
  ].join("&");
  return `otpauth://totp/${label}?${query}`;
};
